import {
  PlayIcon,
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
  ArrowPathIcon,
  ForwardIcon,
} from '@heroicons/react/24/outline';

// Workflow status styling (matches existing job status pattern)
export const WORKFLOW_STATUS_STYLES = {
  PENDING: { bg: 'bg-yellow-500', text: 'text-black', label: 'Pending' },
  RUNNING: { bg: 'bg-blue-500', text: 'text-white', label: 'Running' },
  COMPLETED: { bg: 'bg-green-500', text: 'text-black', label: 'Completed' },
  FAILED: { bg: 'bg-red-600', text: 'text-white', label: 'Failed' },
  CANCELLED: { bg: 'bg-gray-500', text: 'text-white', label: 'Cancelled' },
};

// Step status for DAG nodes
export const STEP_STATUS_CONFIG = {
  PENDING: {
    icon: ClockIcon,
    bgColor: 'bg-gray-800',
    borderColor: 'border-gray-600',
    textColor: 'text-gray-400',
    animate: false,
  },
  RUNNING: {
    icon: ArrowPathIcon,
    bgColor: 'bg-blue-900',
    borderColor: 'border-blue-500',
    textColor: 'text-blue-400',
    animate: true,
  },
  COMPLETED: {
    icon: CheckCircleIcon,
    bgColor: 'bg-green-900',
    borderColor: 'border-green-500',
    textColor: 'text-green-400',
    animate: false,
  },
  FAILED: {
    icon: XCircleIcon,
    bgColor: 'bg-red-900',
    borderColor: 'border-red-500',
    textColor: 'text-red-400',
    animate: false,
  },
  SKIPPED: {
    icon: ForwardIcon,
    bgColor: 'bg-yellow-900',
    borderColor: 'border-yellow-500',
    textColor: 'text-yellow-400',
    animate: false,
  },
};

// Map job types to human-readable labels
export const STEP_TYPE_LABELS = {
  generate_ted_query: 'Generate TED Query',
  check_new: 'Check New Tenders',
  crawl: 'Crawl Tender',
  crawl_all: 'Crawl All Tenders',
  deep_crawl: 'Deep Crawl',
  deep_crawl_all: 'Deep Crawl All',
  convert_documents: 'Convert Documents',
  convert_all_documents: 'Convert All Documents',
  extract_document_text: 'Extract Text',
  extract_tender_documents_text: 'Extract Tender Docs',
  extract_all_documents_text: 'Extract All Text',
  geocode: 'Geocode',
  geocode_all: 'Geocode All',
  index_tender: 'Index Tender',
  index_all_tenders: 'Index All',
  prequalify_tenders: 'Prequalify',
  assess_tender: 'Assess Tender',
  assess_all_tenders: 'Assess All',
  send_saved_search_reports: 'Send Reports',
  run_workflow: 'Run Workflow',
  run_company_workflows: 'Company Workflows',
  sync: 'Sync Tenders',
  refresh_documents: 'Refresh Documents',
  deep_crawl_by_domain: 'Deep Crawl Domain',
  normalize_documents: 'Normalize Documents',
  sync_index: 'Sync Index',
  recreate_index: 'Recreate Index',
  reverse_recreate_index: 'Recreate Reverse Index',
  reverse_index_all_fingerprints: 'Reverse Index Fingerprints',
  search_corpus: 'Search Corpus',
  rescore_corpus_v3: 'Rescore Corpus V3',
  generate_narrative_assessment: 'Generate Narrative',
  generate_narratives_bulk: 'Narratives Bulk',
  generate_facet_analysis: 'Facet Analysis',
  generate_facet_analyses_bulk: 'Facet Analyses Bulk',
  fill_tender_forms: 'Fill Tender Forms',
  tender_download: 'Tender Download',
  cleanup_expired_downloads: 'Download Cleanup',
  send_email: 'Send Email',
  send_renewal_reminders: 'Renewal Reminders',
  send_trial_reminders: 'Trial Reminders',
  backfill_dedup_keys: 'Dedup-Key Backfill',
  backfill_sbund_details: 'Sbund Detail Backfill',
};

// Suppress unused imports warning - icons are referenced by constants
void PlayIcon;
